import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  get,
  patch,
  post,
  put,
} from "helpers/api_helper"
import {
  ADD_REGION,
  DELETE_REGION,
  GET_ALL_REGIONS,
  GET_ALL_REGION_LIST,
  GET_REGION_DETAILS,
  UPDATE_REGION,
  UPDATE_REGION_STATUS,
} from "helpers/url_helper"

export const getAllRegions = createAsyncThunk(
  GET_ALL_REGIONS,
  async payload => {
    const response = await post(GET_ALL_REGIONS, payload)
    return response
  }
)

export const getAllRegionList = createAsyncThunk(
  GET_ALL_REGION_LIST,
  async payload => {
    const response = await get(`${GET_ALL_REGION_LIST}/${payload}`, payload)
    return response
  }
)

export const updateRegionStatus = createAsyncThunk(
  UPDATE_REGION_STATUS,
  async payload => {
    const response = await patch(UPDATE_REGION_STATUS, payload)
    return response
  }
)

export const addRegion = createAsyncThunk(ADD_REGION, async payload => {
  const response = await post(ADD_REGION, payload)
  return response
})

export const getRegionDetails = createAsyncThunk(
  GET_REGION_DETAILS,
  async payload => {
    const response = await post(GET_REGION_DETAILS, payload)
    return response
  }
)

export const updateRegion = createAsyncThunk(UPDATE_REGION, async payload => {
  const response = await put(UPDATE_REGION, payload)
  return response
})

export const deleteRegion = createAsyncThunk(DELETE_REGION, async payload => {
  // const req = { id: payload.id, status: payload.status }
  const response = await del(`${DELETE_REGION}/${payload.id}`)
  return response
})
